// import { useEffect, useState } from 'react'

// import { Icon } from 'semantic-ui-react'

// import css from './supervisor-dashboard.module.css'

// import { HelperService } from '../../services'

// export function SupervisorDashboardPage() {

//     const [companyName, setCompanyName] = useState<string>('')

//     useEffect( () => {

//         const name = HelperService.getCompanyName()

//         setCompanyName(name)

//     }, [])


//     return <div>
//       <h1>Tableau de bord du superviseur</h1>
//       <h3>Contenu à venir</h3>
//     </div>
// }


import React from "react";

import {
    Container,
    Header,
    Grid,
    Segment,
    Statistic,
    Icon,
    Input
} from "semantic-ui-react";


import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    CartesianGrid,
} from "recharts";

export const SupervisorDashboardPage:React.FC = () => {
  const kpis = {
    revenueToday: 1250000,
    transactionsCount: 342,
    agenciesCount: 8,
    cashboxesCount: 34,
    myCashboxBalance: 485000,
    expensesCount: 6,
    expensesTotal: 132000,
    activeUsers: 27,
    openAlerts: 3,
  };

  const revenueByDay = [
    { day: "Lun", amount: 820000 },
    { day: "Mar", amount: 960000 },
    { day: "Mer", amount: 1100000 },
    { day: "Jeu", amount: 980000 },
    { day: "Ven", amount: 1250000 },
    { day: "Sam", amount: 1430000 },
    { day: "Dim", amount: 760000 },
  ];

  const segmentStyle = {
    height: "100%",
    border: "1px solid rgba(0, 0, 0, 0.12)",
    borderRadius: 4,
  };

  const statisticValueStyle = {
    fontSize: "1.15rem",
    marginBottom: "0.75rem",
  };

  return (
    <Container fluid>
      {/* Header + filtres */}
      <Grid>
        <Grid.Row verticalAlign="middle">
          <Grid.Column width={8}>
            <Header as="h2" dividing>
              Dashboard Superviseur
              <Header.Subheader>
                Vue globale de l’activité de l’entreprise
              </Header.Subheader>
            </Header>
          </Grid.Column>

          <Grid.Column width={8} textAlign="right">
            <Input
              type="date"
              style={{ marginRight: "0.5rem" }}
            />
            <Input type="date" />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {/* KPI principaux */}
      <Grid columns={4} stackable style={{ marginBottom: "2rem" }}>
        <Grid.Row stretched>
          <Grid.Column>
            <Segment basic style={segmentStyle}>
              <Statistic size="small">
                <Statistic.Value style={statisticValueStyle}>
                  {kpis.revenueToday.toLocaleString()} FCFA
                </Statistic.Value>
                <Statistic.Label>Chiffre d’affaires</Statistic.Label>
              </Statistic>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment basic style={segmentStyle}>
              <Statistic size="small">
                <Statistic.Value style={statisticValueStyle}>
                  {kpis.transactionsCount}
                </Statistic.Value>
                <Statistic.Label>Transactions</Statistic.Label>
              </Statistic>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment basic style={segmentStyle}>
              <Statistic size="small">
                <Statistic.Value style={statisticValueStyle}>
                  {kpis.agenciesCount}
                </Statistic.Value>
                <Statistic.Label>Agences</Statistic.Label>
              </Statistic>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment basic style={segmentStyle}>
              <Statistic size="small">
                <Statistic.Value style={statisticValueStyle}>
                  {kpis.cashboxesCount}
                </Statistic.Value>
                <Statistic.Label>Caisses</Statistic.Label>
              </Statistic>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {/* KPI financiers personnels */}
      <Grid columns={2} stackable style={{ marginBottom: "2rem" }}>
        <Grid.Row stretched>
          <Grid.Column>
            <Segment basic style={segmentStyle}>
              <Header as="h4">
                <Icon name="closed captioning outline" />
                Ma caisse
              </Header>
              <Statistic size="small">
                <Statistic.Value style={statisticValueStyle}>
                  {kpis.myCashboxBalance.toLocaleString()} FCFA
                </Statistic.Value>
              </Statistic>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment basic style={segmentStyle}>
              <Header as="h4">
                <Icon name="arrow down" />
                Dépenses
              </Header>
              <Statistic size="small">
                <Statistic.Value style={statisticValueStyle}>
                  {kpis.expensesCount} |{" "}
                  {kpis.expensesTotal.toLocaleString()} FCFA
                </Statistic.Value>
                <Statistic.Label>
                  Nombre | Total dépensé
                </Statistic.Label>
              </Statistic>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {/* Opérationnel */}
      <Grid columns={2} stackable style={{ marginBottom: "2rem" }}>
        <Grid.Row stretched>
          <Grid.Column>
            <Segment basic style={segmentStyle}>
              <Header as="h4">
                <Icon name="users" />
                Utilisateurs actifs
              </Header>
              <Statistic size="small">
                <Statistic.Value style={statisticValueStyle}>
                  {kpis.activeUsers}
                </Statistic.Value>
              </Statistic>
            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment basic style={segmentStyle}>
              <Header as="h4">
                <Icon name="warning sign" />
                Alertes ouvertes
              </Header>
              <Statistic size="small">
                <Statistic.Value style={statisticValueStyle}>
                  {kpis.openAlerts}
                </Statistic.Value>
              </Statistic>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {/* Évolution du CA */}
      <Segment basic style={segmentStyle}>
        <Header as="h4">Évolution du chiffre d’affaires</Header>
        <div style={{ width: "100%", height: 300 }}>
          <ResponsiveContainer>
            <LineChart data={revenueByDay}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="amount"
                stroke="#2185d0"
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </Segment>
    </Container>
  );
};

// ------------------------ KPI pris à l'instant

// nombre d'agence
// nombre caisses
// nombre users


// ------------------------ KPI pris sur une période, par defaut dans la journée

// montant total dans le réseau
// caisse du superviseur: montant restant dans la caisse,
// nombre de dépenses & montant total dépensé

// top caisses


// Evolution du CA par jour: line chart






// page "Ma caisse" pour le sup


// xxxxxx nombre de transactions input/output ?????????? xxxxxxx

// types de transacions: intra / inter

// Alertes ouvertes: à definir
